import axios from 'axios';
const TIMEOUT = 10000;

export function get(url, headers = {}, params = {}, cancelToken = null) {
    const response = axios({
        method: 'GET',
        url,
        headers,
        timeout: TIMEOUT,
        cancelToken,
        params,
    });
    return response;
}
  
export function post(url, headers = {}, data = {}, cancelToken = null) {
    const response = axios({
        method: 'POST',
        url,
        headers,
        timeout: TIMEOUT,
        data,
        cancelToken,
    });
    return response;
}
